import { render, staticRenderFns } from "./iatiaktarim.vue?vue&type=template&id=0dcda823&"
import script from "./iatiaktarim.vue?vue&type=script&lang=js&"
export * from "./iatiaktarim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports